/*
 *
 * PublicViewEvent
 *
 */

import React, { useEffect, useState, useCallback } from 'react';


import { Helmet } from 'react-helmet';

import setLanguageContent from 'helpers/setLanguageContent';

import PublicViewEventWrapperNotFound from './styles/PublicViewEventWrapperNotFound';

import RendererComponent from './RendererComponent';

import {
  selectCurrentPage
} from './helpers';


window.anonUserIdString;
window.anonUserIdStringSession = new Date().valueOf() + '-' +  Math.floor(Math.random() * 99999).toString() + '-' + new Date().valueOf() + '-' +  Math.floor(Math.random() * 99999).toString();
window.analyticsPageTimer = 0;
window.analyticsSessionTimer = 0;

window.mesureWebPerformanceStart = true;

window.guessTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


window.isInitial = true;


window._analyticsPageTimerInterval = setInterval(() => {
  if (document.hidden) return;
  window.analyticsPageTimer = window.analyticsPageTimer + 1000;
}, 1000);

window._analyticsSessionTimerInterval = setInterval(() => {
  if (document.hidden) return;
  window.analyticsSessionTimer = window.analyticsSessionTimer + 1000;
}, 1000);

window.urlSearchParams = {};

const urlSearch = new URLSearchParams(window.location.search);

if (urlSearch) {
  urlSearch.forEach(function (val, key) {
    if (key.includes('utm_')) window.urlSearchParams[key] = val;
  });  
}

function getPageSlug(params, thisEventData) {
  
  if (!thisEventData) return;

  const {
    pageSlug
  } = params;

  const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? pageSlug : '/';
  return selectCurrentPage(thisEventData, thisPageSlug);

}

function handleResize() {
  const windowWidthInner = window.innerWidth;

  let thisSize = '';

  if (windowWidthInner <= 600) {
    thisSize = '37_5';
  } else if (windowWidthInner <= 1228) {
    thisSize = '76_8';
  }

  return thisSize;
}

function PublicViewEvent(props) {

  const thisEventData = props.eventData ? props.eventData : window.eventData;
  const templateSchema = thisEventData?.template?.templateSchema;
  const organizationData = thisEventData?.template?.organizationData;

  const {
    params      
  } = props;

  const {
    chapterSlug,
    pageSlug,
    secondSlug
  } = params;



  const [currentPage, setCurrentPage] = useState(getPageSlug(params, thisEventData)?.pageId);
  const [windowWidth, setWindowWidth] = useState(handleResize());
  const [pageContent, setPageContent] = useState('');
  const [sectionsContent, setSectionsContent] = useState('');
  
  useEffect(() => {
    const setPage = getPageSlug(params, thisEventData)?.pageId;
    if (currentPage && setPage !== currentPage) {
      handleAnalytics(false, 'pageviewend');
      if (window._analyticsPageTimerInterval) clearInterval(window._analyticsPageTimerInterval);
      window.analyticsPageTimer = 0;
      window._analyticsPageTimerInterval = setInterval(() => {
        if (document.hidden) return;
        window.analyticsPageTimer = window.analyticsPageTimer + 1000;
      }, 1000);
    }


    if (thisEventData) {

      if (!setPage) return;


      if (typeof gtag === 'function') {
        gtag('event', 'page_view', {
          page_title: document.title,
          page_location: location.href,
          page_path: location.pathname,
        });
      }

      if (typeof ga === 'function' && !isInitial) {
        if (dataLayer) {
          dataLayer.push({'event': 'PageView'});
        }        
      }

      handleAnalytics(isInitial);

      if (isInitial) isInitial = false;

      if (window && window.customPageView && !window.customPageViewDisable) {
        window.customPageView();
      }
      

    }


    setCurrentPage(setPage);
    window.scrollTo(0, 0);
  }, [params]);


  useEffect(() => {

    function resideEvent() {
      setWindowWidth(handleResize());
    }
    window.addEventListener('resize', resideEvent);
    resideEvent();
    return () => window.removeEventListener('resize', resideEvent);
  }, []); 




  const handleAnalytics = useCallback((initial, event, end) => {


    if (!currentPage) return;

    const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? `/${pageSlug}` : '/';

    const deployEnv = process.env.ACARA_DEPLOY_ENV;

    const protocol = deployEnv === 'production' ?  'https://analytics.acara.io' : deployEnv === 'staging' ? 'https://staginganalytics.acara.io' : 'http://localhost:3000';

    let isExternalReferrer = document.referrer && location.origin == new URL(document.referrer).origin ? null : document.referrer ? document.referrer : null;

    let paramsList;

    const urlSearch = new URLSearchParams(location.search);

    if (urlSearch) {
      paramsList = {};
      urlSearch.forEach(function (val, key) {
        if (key.includes('utm_') || key.includes('ref')) paramsList[key] = val;
      });  
    }

    const thisPayload = {
      templateId: templateSchema.templateId,
      organizationId: organizationData.organizationId,
      domain: location.hostname,
      slug: thisPageSlug,
      pageId: currentPage,
      referrer: isExternalReferrer,
      location: location.href.split('?')[0],
      type: event ? event : end ? 'sessionend' : initial ? 'initialview' : 'pageview',
      pageTitle: document.title,
      pagePath: location.pathname,
      timezone: guessTimezone,
      params: paramsList,
      anonUserIdStringSession: anonUserIdStringSession,
      version: 1
    };

    if (event === 'pageviewend') {
      thisPayload.timeOnPage = analyticsPageTimer >= 0 ? analyticsPageTimer : 0;
      if (mesureWebPerformanceStart && thisPayload.timeOnPage) {
        thisPayload.pageLoadTime = performance.getEntriesByType("navigation")[0].duration;
        mesureWebPerformanceStart = false;
      }
    }

    if (end)  {
      thisPayload.sessionTime = analyticsSessionTimer >= 0 ? analyticsSessionTimer : 0;
      thisPayload.timeOnPage = analyticsPageTimer >= 0 ? analyticsPageTimer : 0;

      if(navigator.sendBeacon) {
        navigator.sendBeacon(protocol+'/analytics', JSON.stringify(thisPayload));
      }
      return;
    }

    fetch(protocol+'/analytics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify(thisPayload)
    }).then(response => {
      return response.json().then(responseData => {
        if (responseData.anonUserIdString) anonUserIdString = responseData.anonUserIdString;
        return;
      });
    }).catch(function (err) {
      console.log(err);
    });



  }, [params]);


  useEffect(() => {
    function handleUnload() {
      handleAnalytics(false, false, true);
    }
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []); 






  useEffect(() => {

      if (!templateSchema || !currentPage) return;

      let thisPage = templateSchema.pages.filter((page) => {
        return page.pageId === currentPage;
      });
      if (thisPage && thisPage[0]) thisPage = thisPage[0];

      if (!thisPage) return;
    
      const {
        pages,
        speakers,
      } = templateSchema;
    

      if (!pages) return;

      const {
        sections
      } = thisPage;

      if (!sections) return;


      const isHome = thisPage.slug === '/' || !thisPage.slug;

      const getPageTitle = setLanguageContent(thisPage, thisPage.metaTitle || isHome ? 'metaTitle' : 'title');
      const metaTitle = setLanguageContent(templateSchema, 'metaTitle');

      
      let isSpeaker = '';

      if (chapterSlug === 'speaker' || pageSlug === 'speaker' || secondSlug === 'speaker') {

        for (let index = 0; index < speakers.length; index++) {
          const element = speakers[index];

          if (element.slug === secondSlug || element.slug === pageSlug || element.slug === chapterSlug) {
            isSpeaker = `${element.firstName ? element.firstName : ''} ${element.lastName ? element.lastName : ''} | `;
          }
        }
      }


      const metaTitleState = isSpeaker + `${getPageTitle && !isHome ? getPageTitle+' | ' : '' }` + `${metaTitle ? metaTitle : setLanguageContent(templateSchema, 'title')}`;
      
      setPageContent(
        {
          title: metaTitleState,
          description: thisPage.metaDescription ? thisPage.metaDescription : templateSchema.metaDescription
        }
      );

      setSectionsContent(
        sections.map((section) => {
          const thisSectionData = section;
          if (!thisSectionData || thisSectionData && thisSectionData.isSectionHidden) return;
          return section;
        }).filter((a) => a)
      );


    
  }, [windowWidth, currentPage]);

  return (    
    <div id={'PublicViewEventWrapper-id'}>
      {
        templateSchema && templateSchema.customStyles && templateSchema.customStyles.defaultFont ? (
          <style>
            {`
              #PublicViewEventWrapper-id {
                font-family:${templateSchema.customStyles.defaultFont};
              }
            `}
          </style>
        ): ''
      }
      {templateSchema && templateSchema.templateId && currentPage ? (
        <>
          <Helmet
            title={currentPage.title}
            meta={[
              { name: 'description', content: currentPage.description},
            ]}
          />
          {sectionsContent ? sectionsContent.map((section, indexSection) => {
            return (
              <RendererComponent
                section={section}
                templateSchema={templateSchema}
                pageSlug={pageSlug}
                secondSlug={secondSlug}
                chapterSlug={chapterSlug}
                params={params}
                windowWidth={windowWidth}
                currentPage={currentPage}
                key={`PublicViewEvent-RendererComponent-`+section.sectionId}
                thisSectionData={section}
                indexSection={indexSection}
              />
            );
          }) : ''}
        </>
      ) : (
        <>
          <Helmet
            title={setLanguageContent(templateSchema, templateSchema?.metaTitle ? 'metaTitle' : 'title')}
            meta={[
              { name: 'description', content: templateSchema?.metaDescription },
            ]}
          />
          <PublicViewEventWrapperNotFound>{window.errorTextVar ? window.errorTextVar : '404 - Nothing here... :('} <br/><br/>Go back to <a href={'https://acara.io/'} rel={'noopener'} >Acara</a></PublicViewEventWrapperNotFound>     
        </>
      )}
    </div>
  );
}

export default PublicViewEvent;


